import React, { useState, useEffect } from 'react';
import { Tabs, Row } from 'antd';
import PropTypes from 'prop-types';

import Boards from './Boards';
import BoardExports from './BoardExports';

const tabStyle = { paddingTop: 7, overflowY: 'auto', height: '90vh' };

const { TabPane } = Tabs;

export default function BoardsMain({
  visible,
  activeKey = 'cardTypes',
}) {
  const [stateKey, setStateKey] = useState(activeKey);

  useEffect(() => {
    setStateKey(activeKey);
  }, [activeKey]);

  return (
    <Row justify="start" style={{ height: '90%' }}>
      <Tabs
        defaultActiveKey={activeKey}
        tabPosition="left"
        tabBarStyle={{
          marginTop: 15,
          width: 135,
          marginRight: 17,
        }}
        style={{ width: '100%' }}
        activeKey={stateKey}
        onChange={setStateKey}
      >
        <TabPane style={tabStyle} tab="Card Types" key="cardTypes">
          <Boards visible={visible} />
        </TabPane>
        <TabPane style={tabStyle} tab="Exports" key="exports">
          <BoardExports visible={visible} />
        </TabPane>
      </Tabs>
    </Row>
  );
}

BoardsMain.propTypes = {
  visible: PropTypes.bool.isRequired,
  activeKey: PropTypes.string,
};

BoardsMain.defaultProps = {
  activeKey: 'cardTypes',
}; 